import React from 'react'
import {Link, graphql, useStaticQuery} from 'gatsby'
//import "./header.module.scss"
import headerStyles from './header.module.scss'


const Header = () => {
    const data = useStaticQuery(graphql` 
        query{
            site{
                siteMetadata {
                    title
                }
            }
        }
    `)

    return (
        <header className={headerStyles.header}>
            {/* <Link to="/" className={headerStyles.hero}><img src={require("../img/HAMRYPHOTO_logo.svg")} alt="hero-img" className={headerStyles.hero_img}></img></Link> */}
            <nav className={headerStyles.nav}>
                <ul className={headerStyles.navList}>
                    <li>
                        
                        <Link className={headerStyles.navItem}  activeClassName={headerStyles.activeNavItem} to="/about">
                        <img src={require("../img/account.svg")} alt="nav icon" className={headerStyles.icon}></img>
                        o mnie</Link>
                    </li>
                    <li>
                        
                        <Link  className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem} to="/#oferta">
                        <img src={require("../img/check.svg")} alt="nav icon" className={headerStyles.icon}></img>
                        oferta</Link>
                    </li>
                    <li>
                       
                        <Link className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem} to="/#portfolio">
                        <img src={require("../img/mountain.svg")} alt="nav icon" className={headerStyles.icon}></img>
                        portfolio</Link>
                    </li>
                    <li>
                        
                        <Link className={headerStyles.navItem} activeClassName={headerStyles.activeNavItem} to="/#contact">
                        <img src={require("../img/phone.svg")} alt="nav icon" className={headerStyles.icon}></img>
                        Kontakt</Link>
                    </li>
                </ul>
            </nav>
        </header>
    )
}

export default Header